import { Search, FileCheck, Handshake, Wallet, Star, UserPlus } from "lucide-react";

const clients = [
  { i: FileCheck, t: "Post your requirement", d: "Post a job, service request, or project for bidding." },
  { i: Search, t: "Review verified applicants", d: "Compare profiles, ratings, licenses, and bids." },
  { i: Handshake, t: "Agree on the contract", d: "Set scope, milestones, and terms." },
  { i: Wallet, t: "Pay safely & review", d: "Funds held in escrow, released on approval." },
];
const workers = [
  { i: UserPlus, t: "Create your profile", d: "Build a résumé or list your services." },
  { i: Star, t: "Verify identity & skills", d: "Get verified badges and trust score." },
  { i: Search, t: "Apply or bid", d: "Apply for jobs or submit sealed bids." },
  { i: Wallet, t: "Complete & get paid", d: "Deliver the work, get paid securely." },
];

function Track({ title, steps, tone }: { title: string; steps: typeof clients; tone: string }) {
  return (
    <div className="card p-6">
      <h3 className="font-extrabold text-navy text-lg mb-5">{title}</h3>
      <div className="space-y-4">
        {steps.map((s, i) => {
          const I = s.i;
          return (
            <div key={s.t} className="flex gap-3">
              <div className={`w-10 h-10 rounded-lg grid place-items-center shrink-0 ${tone}`}><I className="w-5 h-5" /></div>
              <div><div className="font-semibold text-navy">{i + 1}. {s.t}</div><div className="text-sm text-mut">{s.d}</div></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function HowItWorks() {
  return (
    <div className="container-x py-10">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <h1 className="text-3xl font-extrabold text-navy">How KontrataPH Works</h1>
        <p className="text-mut mt-2">One trusted platform to hire, work, offer services, and win contracts — with verification, secure contracts, and escrow-protected payments.</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <Track title="For Clients" steps={clients} tone="bg-brand-red/10 text-brand-reddark" />
        <Track title="For Workers" steps={workers} tone="bg-brand-green/10 text-brand-greendark" />
      </div>
    </div>
  );
}
